module.exports = __webpack_public_path__ + "static/media/slider-3.4582fdb4.jpg";